export const locale = {
    skills: "zdolności"
}


  String.prototype.capitalize = function (): string {
    if (!this) return ""; // Handle empty strings
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
  };
  
  // Extend the String interface to include the new method
  declare global {
    interface String {
      capitalize(): string;
    }
  }